import styled from 'styled-components';

export const CarouselCardBox = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  flex-basis: 18%;
  padding-right: 1.875em;
  box-shadow: 1px 1px 3px 0 rgba(0, 0, 0, 0.16);
  background-color: #fff;
  box-shadow: 1px 1px 3px 0 rgb(0 0 0 / 16%);
  background-color: #fff;
  margin-right: 15px;
  margin-bottom: 10px;
  border-radius: 20px;
  padding: 14px 14px 0;
  margin-top: 10px;

  @media (max-width: 720px) {
    flex-basis: 60%;
    padding-right: 0.875em;
    &:nth-child(1) {
      margin-left: 10px;
    }
  }

  iframe {
    min-width: auto !important;
    max-height: 296px !important;
    position: relative;
    margin-top: -54px !important;

    .Header {
      display: none !important;
    }
  }
`;

export const InstaUserSection = styled.div`
  display: flex;
  align-items: center;
  column-gap: 8px;

  img {
    border-radius: 50%;
  }
`;

export const InstaFollower = styled.span`
  font-size: 12px;
  font-weight: 500;
  display: flex;
  align-items: center;
  column-gap: 4px;
  margin-top: 2px;

  img {
    border-radius: 0 !important;
  }
`;

export const InstaUsername = styled.span`
  font-size: 14px;
  font-weight: 500;
`;

export const Followers = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HiddenDiv = styled.div`
  overflow: hidden;
`;

export const CardContent = styled.p`
  font-size: clamp(12px, 2vw, 15px);
  font-weight: 500;
  color: hsl(0deg, 0%, 0%, 87%);
  line-height: 1.5;
  text-align: center;
  padding: 8px 10px 20px;

  @media (max-width: 720px) {
    padding: 12px 0 8px;
  }
`;

export const RelativeDiv = styled.div`
  position: relative;
  background-image: url(/images/greenwavetwo.svg);
  background-size: cover;
  top: -1px;
`;

export const SectionTitle = styled.div`
  text-align: center;
  padding: 0 10px 30px;

  h2 {
    display: inline-block;
    color: hsl(0deg, 0%, 0%, 80%);
    position: relative;
    font-size: clamp(16px, 2vw, 24px);
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 4px;
    position: relative;

    @media (max-width: 720px) {
      letter-spacing: 0.5px;
      line-height: 26px;
    }
  }

  @media (max-width: 720px) {
    padding: 0 12px 16px;
  }
`;
